import React, { Component } from 'react'
import Meta from 'components/layout/Meta';
import {actions} from "components/page/pageModule";

import './index.scss'

class Saas extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="banner saas_banner">
          <h1>海外SaaS服务 — 东南亚出海一站式互联网金融科技服务</h1>
          <ul>
            <li><img src={require('./images/saas_1.png')}/> 落地服务方案</li>
            <li><img src={require('./images/saas_2.png')}/> 智能营销</li>
            <li><img src={require('./images/saas_3.png')}/> 智能产品</li>
            <li><img src={require('./images/saas_4.png')}/> 智能风控</li>
            <li><img src={require('./images/saas_5.png')}/> 智能运营</li>
          </ul>
          <div><a href="./services/submitform">方案咨询</a></div>
        </div>
        <div className="wrapPanel">
          <div className="panel saas_panel">
            <h2><span>合作优势</span></h2>
            <ul>
              <li>
                <img src={require('./images/icon_1.png')}/>
                <h3>产品优势</h3>
                <p>以人工智能、大数据、云计算等科技手段，为产品赋能，并结合业务实操经验，打造覆盖全流程的一站式落地产品服务。</p>
              </li>
              <li>
                <img src={require('./images/icon_1.png')}/>
                <h3>技术优势</h3>
                <p>拥有独立开发的完整海外产品模型、技术系统;具备多年人工智能、 生物识别、大数据技术方面的成功应用经验。</p>
              </li>
            </ul>
            <ul className="saas_ul">
              <li>
                <img src={require('./images/icon_1.png')}/>
                <h3>产品优势</h3>
                <p>以人工智能、大数据、云计算等科技手段，为产品赋能，并结合业务实操经验，打造覆盖全流程的一站式落地产品服务。</p>
              </li>
              <li>
                <img src={require('./images/icon_1.png')}/>
                <h3>技术优势</h3>
                <p>拥有独立开发的完整海外产品模型、技术系统;具备多年人工智能、 生物识别、大数据技术方面的成功应用经验。</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="saas_img">
          <p className="saas_des">东南亚市场先行和领先者应用金融科技助力东南亚普惠金融发展</p>
        </div>
      </div>
    )
  }
}


export default Saas



// WEBPACK FOOTER //
// ./modules/services/Saas.js